import { render } from "./UnboxSpinner.vue?vue&type=template&id=1244472f&scoped=true"
import script from "./UnboxSpinner.vue?vue&type=script&lang=js"
export * from "./UnboxSpinner.vue?vue&type=script&lang=js"

import "./UnboxSpinner.vue?vue&type=style&index=0&id=1244472f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1244472f"]])

export default __exports__